module.exports = __webpack_public_path__ + "img/legalServices-7.cd4e73d1.png";